// Country selector
document.addEventListener('DOMContentLoaded', function() {
  var wrapper = document.querySelector('.country-selector-wrapper');
   
  document.querySelectorAll('.country-flag').forEach(function(element) {
    element.addEventListener('click', function(e) {
      e.preventDefault();
      openCountrySelector(wrapper);
    });
  });

  document.querySelector('.csc-footer a').addEventListener('click', function(event) {
    event.preventDefault();
    var select = document.querySelector('.country-selector-options');
    var optionSelected = select.options[select.selectedIndex];
    // If no option selected, stop here, no need for more
    if (!optionSelected || optionSelected && optionSelected.value === '') return;
    var selectedSite = optionSelected.value;
    var selectedCountry = optionSelected.dataset.code;
    var tmp = document.createElement('a');
    tmp.href = selectedSite;
    var mysite = tmp.hostname.split('.', 1).pop();
    var currentSite = new URL(window.location.href);
    var newSite = new URL(selectedSite, window.location.href);
  
    // Always set the cookie to extend its lifetime
    var domain = 'steenshoney.com';
    writeCookie('mysite', mysite, 30, domain);
    writeCookie('mycookie', 'true', 30, domain);
    writeCookie('mycountry', selectedCountry, 30, domain);
    writeCookie('myconfirmed', 'true', 30, domain);
    
    // If we have a different site, then we redirect
    if (currentSite.host !== newSite.host) {
      // Set pathname, search, and hash to match current URL
      newSite.pathname = window.location.pathname;
      newSite.search = window.location.search;
      newSite.hash = window.location.hash;
      // Add or update the 'offer' parameter
      newSite.searchParams.set('offer', 'true');
      // Redirect and return
      window.location.href = newSite.toString();
      return;
    }
    
    // Otherwise, we just close the country selector
    document.querySelector('.country-selector-wrapper').classList.remove('show-country-selector', 'fadeIn');
    document.removeEventListener('mouseup', openCloseListenerCountrySelector);
  });
});

function openCloseListenerCountrySelector(e) {
  var container = document.querySelector('.country-selector-content');
  var wrapper = document.querySelector('.country-selector-wrapper');
  if (!container.contains(e.target) && wrapper.contains(e.target)) {
    wrapper.classList.remove('show-country-selector', 'fadeIn');
    document.removeEventListener('mouseup', openCloseListenerCountrySelector);
  }
}

function openCountrySelector(wrapper) {
  wrapper.classList.add('show-country-selector', 'fadeIn');
  document.addEventListener('mouseup', openCloseListenerCountrySelector);
}

function readCookie(name) {
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(name + '=') === 0) {
      return cookie.substring(name.length + 1, cookie.length);
    }
  }
  return null;
}

function writeCookie(name, value, days, domain) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  var domainString = domain ? "; domain=" + domain : "";
  document.cookie = name + "=" + value + expires + "; path=/" + domainString;
}